<template>
	<div class="accordion-item">
		<button class="accordion-button" @click="toggleAccordion" :class="accordionClass">
			<div class="accordion-item-image" v-if="imageUrl" :style="backgroundImage"></div>
			<div class="accordion-item-title">
				{{title[language]}}
			</div>
		</button>
		<div class="accordion-panel" :class="accordionClass" v-html="body[language]"></div>
	</div>
</template>

<script>

import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';

export default {
	name: 'AccordionItem',
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin],
	props: {
		title: Object,
		body: Object,
		opened: Boolean,
		accKey: Number,
		image: Number,
	},
	computed: {
		accordionClass() {
			return {
				'is-closed': !this.opened,
			};
		},
		imageUrl() {
			if (this.image) {
				const media = this.findInMedia(this.image);
				if (media && media.original_name) {
					return `/storage/media/${media.original_name}`;
				}
			}
			return false;
		},
		backgroundImage() {
			return `background-image: url('${this.imageUrl}')`;
		},
	},
	methods: {
		toggleAccordion() {
			this.$emit('openedItem', this.accKey);
		},
	},
};
</script>

<style src="@/styles/components/AccordionView/AccordionItem.less" lang="less" scoped></style>

